/**
 * Non-ASCII hyphen/dash characters (Unicode) to normalize to ASCII hyphen (U+002D).
 * Covers: HYPHEN, NON-BREAKING HYPHEN, FIGURE DASH, EN DASH, EM DASH,
 * HORIZONTAL BAR, MINUS SIGN, SMALL EM DASH, SMALL HYPHEN-MINUS, FULLWIDTH HYPHEN-MINUS.
 */
export const NON_ASCII_HYPHEN_REGEX = /[\u2010-\u2015\u2212\uFE58\uFE63\uFF0D]/g;

export const ASCII_HYPHEN = '\u002D';
